<script setup lang="ts">
</script>

<template>
  <n-layout>
    <main class="background-index center">
      <slot></slot>
    </main>
  </n-layout>
</template>


<style scoped>
.background-index {
  height: 100vh;
  width: 100vw;
  background: url("../static/bg-login.jpg") bottom;
  background-size: cover;
}
</style>